import { GET_USER_DETAILS, RESET_DETAIL } from "../action/Action";

const initialState = {
    userData: [],
}

const userDetailReducer = (state = initialState, action) => {
    switch (action?.type) {
        case GET_USER_DETAILS:
            return {
                ...state,
                userData: action?.payload
            };
        case RESET_DETAIL:
            return {
                ...state,
                userData: []
            }
        default:
            return state;
    }
}

export default userDetailReducer;